module.exports = __webpack_public_path__ + "static/media/amazon.6f5a872b.svg";